// extracted by mini-css-extract-plugin
export default {"frame":"writeUpForm_frame__kJTAo","frameLabel":"writeUpForm_frameLabel__-Y6x4"};